import React, {useState, useEffect} from 'react'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {DataStep1} from './SettingsModel'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import axios from 'axios'
import Swal from 'sweetalert2'
import {useNavigate} from 'react-router-dom'
import {initialQueryState, KTIcon, useDebounce} from '../../../../_metronic/helpers'
import {CKEditor} from '@ckeditor/ckeditor5-react'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import Switch from '@mui/material/Switch'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'

const profileDetailsSchema = Yup.object().shape({
  deal_name: Yup.string().required(''),
  deal_detail_promote_th: Yup.string().required(''),
  point: Yup.string().required(''),
  deal_expire_min: Yup.string().required(''),
})

const Step1 = (props: any) => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const API_URL = process.env.REACT_APP_API_URL
  const PVL_URL = process.env.REACT_APP_PVL_URLV1
  const PVL_URL2 = process.env.REACT_APP_PVL_URLV2
  const PVL_IMG = process.env.REACT_APP_PVL_IMAGE
  const initialValues: DataStep1 = {
    deal_detail_promote_th: '',
    deal_detail_promote_en: '',
    price: 0,
    deal_name: '',
    deal_name_en: '',
    campaign_id: 29,
    deal_tags: [],
    deal_detail_short: '',
    deal_detail_short_en: '',
    deal_detail_condition: '',
    deal_detail_condition_en: '',
    deal_image: '',
    deal_expire_min: 0,
    point: 0,
    deal_display_weight: 0,
    is_delivery: false,
    is_lucky: false,
    is_active: false,
    deal_active: false,
    is_show_on_front: false,
  }
  const dataLocal = localStorage.getItem('data1')
  const dataTemp = dataLocal ? JSON.parse(dataLocal) : {tagData: [{tag_name: ''}]}
  const [text, setText] = useState<any>('')
  const [dealDetail, setDealDetail] = useState<any>('')
  const [price, setPrice] = useState<any>('')
  const [brand, setDealBrand] = useState<any>('')
  const [detailShort, setDetailShort] = useState<any>('')
  const [condition, setCondition] = useState<any>('')
  const [category, setCategory] = useState<any>([])
  const [image, setImage] = useState<any>('')
  const [point, setPoint] = useState<any>(0)
  const [time, setTime] = useState<any>(0)
  const [order, setOrder] = useState<any>(0)
  const [active, setActive] = useState<any>(false)
  const [show, setShow] = useState<any>(false)
  const [delivery, setDelivery] = useState<any>(false)
  const [lucky, setLucky] = useState<any>(false)
  const [data, setData] = useState<DataStep1>(initialValues)
  const [tagData, setTagData] = useState<any>(dataLocal ? dataTemp.tagData : props.editData ? props.editData.dealTags : [])
  const [tag, setTag] = useState([{tag_name: ''}])
  const [change, setChange] = useState(false)

  const updateData = (fieldsToUpdate: Partial<DataStep1>): void => {
    const updatedData = Object.assign(data, fieldsToUpdate)
    setData(updatedData)
  }
  const editorConfiguration = {
    // Other configuration options...
    editorConfig: {
      // Set the default text color here
      fontColor: 'red',
    },
  }
  const AlertError = (message: string) => {
    Swal.fire('', message, 'error')
  }
  const getTag = async () => {
    const data = await axios.get(`${API_URL}/privilege/getTagAll`)
    let temp: any = []
    await Promise.all(
      data.data.map((item: any) => {
        temp.push({
          tag_name: item.tag_name,
          tag_id: item.id,
        })
      })
    )
    setTag(temp)
    //setingTag(temp)
  }

  const getStep1Data = async () => {
    if (dataLocal) {
      const dataJson = JSON.parse(dataLocal)
      setDealDetail(dataJson.deal_name)
      setPrice(dataJson.price)
      setDealBrand(dataJson.deal_detail_promote_th)
      setDetailShort(dataJson.deal_detail_short)
      setCondition(dataJson.deal_detail_condition)
      setImage(dataJson.deal_image)
      setPoint(dataJson.point)
      setTime(dataJson.deal_expire_min)
      setOrder(dataJson.deal_display_weight)
      setActive(dataJson.is_active)
      setShow(dataJson.is_show_on_front)
      setDelivery(dataJson.is_delivery)
      setLucky(dataJson.is_lucky)
      setTagData(dataJson.tagData)
    }
    if (props.editData) {
      console.log(props.editData)
      setDealDetail(props.editData.deal_name)
      setPrice(props.editData.price)
      setDealBrand(props.editData.deal_detail_promote_th)
      setDetailShort(props.editData.deal_detail_short)
      setCondition(props.editData.deal_detail_condition)
      setPoint(props.editData.point)
      setTime(props.editData.deal_expire_min)
      setOrder(props.editData.deal_display_weight)
      setActive(props.editData.deal_active)
      setShow(props.editData.is_show_on_front)
      setDelivery(props.editData.is_delivery)
      setLucky(props.editData.is_lucky)
      setTagData(props.editData.tagData)
      let dataImg = props.editData.deal_image.split('/')
      setImage(dataImg[4])
    }
  }

  const setingTag = async(tag: any) => {
    let temp: any = []
    await Promise.all(props.editData.tags.map((item: any) => {
      let tempfilter = item.split('-')
      let fil = tempfilter[1].split(' ')
      let tagEdit = tag.filter((x:any) => x.tag_name == fil[1])
      temp.push(tagEdit[0])
    }))
    setTagData(temp)
  }

  useEffect(
    () => {
      //console.log('props.editTag', props.editData.dealTags)
      getTag()
      getStep1Data()
    },
    [] // Only re-call effect if value or delay changes
  )

  const uploadImage = async (e: any) => {
    if (e.target.files.length) {
      //e.preventDefault()
      var _URL = window.URL || window.webkitURL
      var file = e.target.files[0]
      var formdata = new FormData()
      formdata.append('image', file)
      var requestOptions = {
        method: 'POST',
        body: formdata,
        redirect: 'follow',
      }
      const data = await axios.post(`${PVL_URL}/upload`, formdata)
      setImage(data.data.filename)
      setChange(true)
    }
  }

  const create = async () => {
    let temp: any = []
    tagData.map((item: any) => {
      temp.push(item.tag_id)
    })
    const body = {
      deal_detail_promote_th: brand,
      deal_detail_promote_en: brand,
      price: price,
      deal_name: dealDetail,
      deal_name_en: dealDetail,
      campaign_id: '29',
      deal_tags: temp,
      deal_detail_short: detailShort,
      deal_detail_short_en: detailShort,
      deal_detail_condition: condition,
      deal_detail_condition_en: condition,
      deal_image: image,
      deal_expire_min: time,
      point: point,
      deal_display_weight: order,
      is_delivery: delivery,
      is_lucky: lucky,
      is_active: active,
      deal_active: true,
      is_show_on_front: show,
      created_by: '1',
      created_by_id: '1',
      tagData: tagData,
    }
    if (props.dataID !== 1 && !change) {
      props.click(1)
    } else
      Swal.fire({
        title: '',
        text: !props.editTag ? 'Confirm Create' : 'Confirm Edit',
        icon: 'info',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        showLoaderOnConfirm: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          if (props.editData) {
            const data = await axios
              .put(`${PVL_URL2}/deal/${props.editData.id}`, body)
              .then(async (res) => {
                props.setdataID(res.data.data.id)
                const myJSON = JSON.stringify(body)
                localStorage.setItem('data1', myJSON)
                await Swal.fire('Success', 'Success', 'success')
                props.click(1)
              })
              .catch((err) => {
                Swal.fire('Edit !', 'Your can not Edit. !! ' + err, 'error')
              })
          } else {
            const data = await axios
              .post(`${PVL_URL2}/deal`, body)
              .then(async (res) => {
                props.setdataID(res.data.data.id)
                const myJSON = JSON.stringify(body)
                localStorage.setItem('data1', myJSON)
                await Swal.fire('Success', 'Success', 'success')
                props.click(1)
              })
              .catch((err) => {
                Swal.fire('Create !', 'Your can not Create. !! ' + err, 'error')
              })
          }
        }
      })
  }

  const formik = useFormik<DataStep1>({
    initialValues,
    validationSchema: profileDetailsSchema,
    onSubmit: (values) => {
      setLoading(true)
      setTimeout(async () => {
        //values.communications.email = data.communications.email
        //values.communications.phone = data.communications.phone
        //values.allowMarketing = data.allowMarketing
        const updatedData = Object.assign(data, values)
        setData(updatedData)
        Swal.fire({
          title: '',
          text: 'Confirm Edit',
          icon: 'info',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          showLoaderOnConfirm: true,
        }).then(async (result) => {
          if (result.isConfirmed) {
            const data0 = await axios
              .put(`${API_URL}/bo/participant/${1}`, {
                //firstname: values.fName,
                //lastname: values.lName,
                //mobile_number: values.contactPhone,
              })
              .then(async (res) => {
                await Swal.fire('Success', 'Success', 'success')
                navigate(-1)
              })
              .catch((err) => {
                Swal.fire('Edit !', 'Your can not Edit. !! ' + err, 'error')
              })
          }
        })

        setLoading(false)
      }, 1000)
    },
  })

  return (
    <div className='card mb-5 mb-xl-10'>
      <div id='kt_account_profile_details' className='collapse show'>
        <form onSubmit={formik.handleSubmit} noValidate className='form'>
          <div className='card-body border-top p-9'>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>ชื่อรางวัล</label>
              <div className='col-lg-6 fv-row'>
                <input
                  value={dealDetail}
                  onChange={(e: any) => {
                    setDealDetail(e.target.value)
                    setChange(true)
                  }}
                  type='text'
                  className='form-control form-control-lg form-control-solid'
                  placeholder=''
                  //{...formik.getFieldProps('deal_name')}
                />
              </div>
            </div>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>ชื่อแบรนด์</label>
              <div className='col-lg-6 fv-row'>
                <input
                  value={brand}
                  onChange={(e: any) => {
                    setDealBrand(e.target.value)
                    setChange(true)
                  }}
                  type='text'
                  className='form-control form-control-lg form-control-solid'
                  placeholder=''
                />
              </div>
            </div>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>ราคา</label>
              <div className='col-lg-6 fv-row'>
                <input
                  value={price}
                  type='number'
                  className='form-control form-control-lg form-control-solid'
                  placeholder=''
                  onChange={(e: any) => {
                    setPrice(e.target.value)
                    setChange(true)
                  }}
                />
              </div>
            </div>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>รายละเอียดการแลก</label>
              <div className='col-lg-6 fv-row'>
                <CKEditor
                  editor={ClassicEditor}
                  data={condition}
                  config={{
                    toolbar: [
                      'heading',
                      '|',
                      'bold',
                      'italic',
                      'blockQuote',
                      'link',
                      'numberedList',
                      'bulletedList',
                      'imageUpload',
                      'insertTable',
                      'tableColumn',
                      'tableRow',
                      'mergeTableCells',
                      'mediaEmbed',
                      '|',
                      'undo',
                      'redo',
                    ],
                  }}
                  onReady={(editor) => {
                    // You can store the "editor" and use when it is needed.
                  }}
                  onChange={(event, editor) => {
                    const data = editor.getData()
                    setCondition(editor.getData())
                    setChange(true)
                  }}
                  onBlur={(event, editor) => {
                  }}
                  onFocus={(event, editor) => {
                  }}
                />
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>รายละเอียดรางวัล</label>
              <div className='col-lg-6 fv-row'>
                <CKEditor
                  editor={ClassicEditor}
                  data={detailShort}
                  config={{
                    toolbar: [
                      'heading',
                      '|',
                      'bold',
                      'italic',
                      'blockQuote',
                      'link',
                      'numberedList',
                      'bulletedList',
                      'imageUpload',
                      'insertTable',
                      'tableColumn',
                      'tableRow',
                      'mergeTableCells',
                      'mediaEmbed',
                      '|',
                      'undo',
                      'redo',
                    ],
                  }}
                  onReady={(editor) => {
                    // You can store the "editor" and use when it is needed.
                  }}
                  onChange={(event, editor) => {
                    const data = editor.getData()
                    setDetailShort(editor.getData())
                    setChange(true)
                  }}
                  onBlur={(event, editor) => {
                  }}
                  onFocus={(event, editor) => {
                  }}
                />
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>Category</label>
              <div className='col-lg-6 fv-row'>
                <Autocomplete
                  multiple
                  id='tags-standard'
                  options={tag}
                  getOptionLabel={(option) => option.tag_name}
                  onChange={(event: any, newValue: any | null) => {
                    setTagData(newValue)
                    setChange(true)
                  }}
                  defaultValue={tagData}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant='standard'
                      //label='Multiple values'
                      //placeholder='Favorites'
                    />
                  )}
                />
              </div>
            </div>

            <div className='row mb-6'>
              <div className='row mb-6'>
                <label className='col-lg-4 col-form-label fw-bold fs-6'>
                  <span>Image</span>
                </label>

                <div className='col-lg-6 fv-row'>
                  <input
                    value={image}
                    type='text'
                    className='inputIMG form-control form-control-lg form-control-solid'
                    placeholder=''
                  />
                </div>
                <div className='col-lg-2 fv-row'>
                  <span className='btn btn-primary btn-file wbt editbtn'>
                    Add
                    <input
                      //disabled={loading}
                      type='file'
                      accept='.jpg,.png,jpeg'
                      onChange={uploadImage}
                    />
                  </span>
                </div>
              </div>
              {image != '' && (
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label fw-bold fs-6'>
                    <span></span>
                  </label>
                  <div className='wbt editbtn'>
                    <img style={{width: '400px'}} src={`${PVL_IMG}/${image}`} />
                  </div>
                </div>
              )}
            </div>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>เวลาหมดอายุ</label>
              <div className='col-lg-6 fv-row'>
                <input
                  value={time}
                  type='number'
                  className='form-control form-control-lg form-control-solid'
                  placeholder=''
                  onChange={(e: any) => {
                    setTime(e.target.value)
                    setChange(true)
                  }}
                />
              </div>
            </div>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>คะแนนที่ใช้แลก</label>
              <div className='col-lg-6 fv-row'>
                <input
                  value={point}
                  type='text'
                  className='form-control form-control-lg form-control-solid'
                  placeholder=''
                  onChange={(e: any) => {
                    setPoint(e.target.value)
                    setChange(true)
                  }}
                />
              </div>
            </div>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>ลำดับการแสดง</label>
              <div className='col-lg-6 fv-row'>
                <input
                  value={order}
                  type='text'
                  className='form-control form-control-lg form-control-solid'
                  placeholder=''
                  onChange={(e: any) => {
                    setOrder(e.target.value)
                    setChange(true)
                  }}
                />
              </div>
            </div>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>เปิดใช้งาน</label>
              <div className='col-lg-6 fv-row'>
                <Switch
                  checked={active}
                  onChange={(e: any) => {
                    setActive(e.target.checked)
                    setChange(true)
                  }}
                />
              </div>
            </div>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>เปิด/ปิด การแสดง</label>
              <div className='col-lg-6 fv-row'>
                <Switch
                  checked={show}
                  onChange={(e: any) => {
                    setShow(e.target.checked)
                    setChange(true)
                  }}
                />
              </div>
            </div>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>แบบจัดส่ง</label>
              <div className='col-lg-6 fv-row'>
                <Switch
                  checked={delivery}
                  onChange={(e: any) => {
                    setDelivery(e.target.checked)
                    setChange(true)
                  }}
                />
              </div>
            </div>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>แบบลุ้นรางวัล</label>
              <div className='col-lg-6 fv-row'>
                <Switch
                  checked={lucky}
                  onChange={(e: any) => {
                    setLucky(e.target.checked)
                    setChange(true)
                  }}
                />
              </div>
            </div>
          </div>
        </form>
      </div>
      <div className='card-footer d-flex justify-content-end py-6 px-9'>
        <button
          //type='submit'
          className='btn btn-primary'
          disabled={loading}
          onClick={async () => {
            //props.handleChild(2)
            //setStep(Number(step) + 1)
            await create()
          }}
        >
          {!loading && 'Next'}
          {loading && (
            <span className='indicator-progress' style={{display: 'block'}}>
              Please wait...{' '}
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>
    </div>
  )
}

export {Step1}
